import {onReady} from "../../utils/events/onReady";
import {hexToCSSFilter} from "hex-to-css-filter";

export class InfoCard {
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }

    init() {
        // Blocks
        const notificationBlock = this.dom.container.querySelector(
            ".infocard__notification"
        );

        if (this.dom.container.querySelector(".infocard__quote")) {
            const quoteBlock =
                this.dom.container.querySelector(".infocard__quote");

            // Hex Values
            const quoteHexValue =
                quoteBlock.querySelector(".hide-hex-quote")?.dataset.hex;
            const notificationHexValue = notificationBlock.querySelector(
                ".hide-hex-notification"
            )?.dataset.hex;

            let notificationImage = notificationBlock
                .querySelector("img.info-notification-image");
            let quoteImage = quoteBlock
                .querySelector("img.info-quote-image");

            if (notificationImage && notificationHexValue) {
                notificationImage.setAttribute(
                    "style",
                    `width: 120px; filter:${
                        hexToCSSFilter(notificationHexValue).filter
                    }`
                );
            }

            if (quoteImage && quoteHexValue) {
                quoteImage.setAttribute(
                    "style",
                    `width: 120px; filter:${
                        hexToCSSFilter(quoteHexValue).filter
                    }`
                );
            }
        }
    }
}
